/** Returns a react-hook-form validate function that checks the value matches the reference string. */
export const mustMatch =
  (reference: string, message = "Passwords must match") =>
  (value: string) =>
    value === reference || message;

/** Minimum length for a new password, matching the server password policy (NCSC / NIST). */
export const PASSWORD_MIN_LENGTH = 12;

/** Maximum accepted length for password fields, enforced client-side to match the server rule. */
export const PASSWORD_MAX_LENGTH = 64;

/** HTML input limits count UTF-16 code units rather than Unicode characters. */
export const PASSWORD_MAX_INPUT_LENGTH = PASSWORD_MAX_LENGTH * 2;

export const validatePasswordLength = (value: string, minimumLength = 0): true | string => {
  const length = Array.from(value).length;
  if (length < minimumLength) return `Password must be at least ${minimumLength} characters`;
  return length <= PASSWORD_MAX_LENGTH || `Password must be at most ${PASSWORD_MAX_LENGTH} characters`;
};

export const validateNewPassword = (value: string): true | string =>
  validatePasswordLength(value, PASSWORD_MIN_LENGTH);

/** Safely decodes a URI component, returning the original string if decoding fails. */
export const safeDecodeURIComponent = (s: string) => {
  try {
    return decodeURIComponent(s);
  } catch {
    return s;
  }
};

/**
 * Guards against open-redirect attacks: only allows same-origin, relative
 * paths (e.g. "/dashboard"). Rejects absolute URLs, protocol-relative URLs
 * ("//evil.com") and anything else that could send the user off-site.
 */
export const safeRedirectPath = (url?: string | null, fallback = "/") => {
  if (!url) return fallback;
  if (!url.startsWith("/") || url.startsWith("//") || url.startsWith("/\\")) return fallback;
  return url;
};
